import * as types from './mutation-types'

export default {
    [types.LOAD_LOCATION](state, data) {
      state.stockLocation = data.data
    },
  
  [types.ADD_SCROLL_STOCK_DATA] (state, {data, query}) {
    const stocks = Array.isArray(data.data) ? data.data : Object.values(data.data)
    if(state.stockScrollMeta.currentQuery !== query || data.current_page === 1 ) {
      state.stockScroll = stocks
    } else {
      state.stockScroll = state.stockScroll.concat(stocks)
    }
    state.stockScrollMeta.current_page = data.current_page
    state.stockScrollMeta.last_page = data.last_page
    state.stockScrollMeta.currentQuery = query
  },

  [types.ADD_NEXT_STOCK] (state, data) {
    state.stockScroll = [...state.stockScroll, ...data.stocks]
  },
  

}
